import "../../lib/form/form.scss";
import "../Main.scss";
import Sub from "../Sub";
import "./ReviewCompletionStatus.scss";

import axios from "axios";
import { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import ReviewCompletionStatusDetail from "./ReviewCompletionStatusDetail";

function ReviewCompletionStatus() {
  let navigate = useNavigate();
  let { id } = useParams();
  const [menuData, setMenuData] = useState([]);
  const [resultData, setResultData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [showModal, setShowModal] = useState(false);

  //  search Filter
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  // 검색필터 데이터
  const [applicantName, setApplicantName] = useState("");
  const [workflowName, setWorkflowName] = useState("");
  const [verifiedNum, setVerifiedNum] = useState("");
  const [status, setStatus] = useState("");

  const resetHandler = () => {
    setStartDate("");
    setEndDate("");
    setWorkflowName("");
    setApplicantName("");
    setVerifiedNum("");
    setStatus("");
  };

  const closeModal = () => {
    setShowModal(false);
  };
  const getCompleteData = async () => {
    try {
      const response = await axios.get("/api/apply-proc-result", {
        params: {
          qualificationNumLike: verifiedNum,
          pageNumber: page,
          pageSize: 15,
          workflowId: workflowName,
          companyName: applicantName,
          startDate,
          endDate,
          state: status,
          sortField: "qualificationDate",
          sortOrder: "dsc",
        },
      });
      setResultData(response.data.data);
      setTotalItems(response.data.recordsFiltered);
    } catch (err) {
      console.log(err);
    }
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const inputHandler = (event) => {
    if (event.target.name === "applicantName") {
      setApplicantName(event.target.value);
    }
    if (event.target.name === "verifiedNum") {
      setVerifiedNum(event.target.value);
    }

    if (event.target.name === "startDate") {
      setStartDate(event.target.value);
    }
    if (event.target.name === "endDate") {
      setEndDate(event.target.value);
    }
  };

  const selectHandler = (event) => {
    setWorkflowName(event.target.value);
  };
  const statusHandler = (event) => {
    setStatus(event.target.value);
  };
  const getMenuData = async () => {
    const response = await axios.get("/api/workflow");
    setMenuData(
      response.data.data.filter((workflow) => workflow.name !== "C-ITS 분야")
    );
  };

  useEffect(() => {
    getCompleteData();
    getMenuData();
  }, [page]);

  return (
    <>
      {showModal ? (
        <div className="popup_bg_bbs " onClick={closeModal}>
          <div
            className="password_change "
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pophead_bbs">
              <h1>재평가/재발급</h1>
            </div>
            <div className="password_change_inner">
              진행하시겠습니까?
              <div className="btns_wrap">
                <button className="btn_color" onClick={closeModal}>
                  <span className="material-icons">취소</span>
                </button>
                <button className="btn_confirm" onClick={closeModal}>
                  <span className="material-icons">확인</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <Sub to={"/reviewcompletionstatus"} title="심사현황" />
      <div className="">
        <div className="customcenter_area">
          <section className="customcenter_title_row">
            <div className="customcenter_title_col">
              <p>심사현황</p>
            </div>
          </section>
          <table
            width="1000px"
            style={{ textAlign: "center", marginLeft: "20vw" }}
          >
            <tbody>
              <tr>
                <td width="50px">
                  <b>분야</b>
                </td>
                <td width="400px">
                  <section
                    className="input_area"
                    style={{ width: "400px", margin: "0 60px" }}
                  >
                    <div className="select_box_contain">
                      <div className="select_box">
                        <select
                          name="select_type"
                          style={{ width: "400px" }}
                          onChange={selectHandler}
                          // value={workflowName}
                        >
                          <option value="">전체</option>
                          {menuData.map((e) => (
                            <option key={e.id} value={e.id}>
                              {e.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
              <tr>
                <td width="50px">
                  <b>상태</b>
                </td>
                <td width="400px">
                  <section
                    className="input_area"
                    style={{ width: "400px", margin: "0 60px" }}
                  >
                    <div className="select_box_contain">
                      <div className="select_box">
                        <select
                          name="select_type"
                          style={{ width: "400px" }}
                          onChange={statusHandler}
                          value={status}
                        >
                          <option value="">전체</option>
                          <option value="1">완료</option>
                          {/* <option value="8">취소</option> */}
                          <option value="13">중지</option>
                          {/* <option value="9">효력정지</option> */}
                        </select>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
              <tr>
                <td width="50px">
                  <b>인증 · 인정번호</b>
                </td>
                <td width="400px">
                  <section
                    className="input_area"
                    style={{ width: "400px", margin: "0 60px" }}
                  >
                    <div className="input_wrap">
                      <input
                        onChange={inputHandler}
                        value={verifiedNum}
                        name="verifiedNum"
                        className="input_line"
                        type="text"
                        placeholder="인증 및 인정번호를 입력하세요"
                      />
                    </div>
                  </section>
                </td>
              </tr>
              <tr>
                <td width="50px">
                  <b>업체명</b>
                </td>
                <td width="400px">
                  <section
                    className="input_area"
                    style={{ width: "400px", margin: "0 60px" }}
                  >
                    <div className="input_wrap">
                      <input
                        onChange={inputHandler}
                        value={applicantName}
                        name="applicantName"
                        className="input_line"
                        type="text"
                        placeholder="업체명을 입력하세요"
                      />
                    </div>
                  </section>
                </td>
              </tr>
              <tr>
                <td width="100px">
                  <b>인증 · 인정일</b>
                </td>
                <td width="300px">
                  <section
                    className="input_area"
                    style={{ width: "400px", margin: "0 60px" }}
                  >
                    <div className="input_wrap input_date">
                      <input
                        id="start"
                        name="startDate"
                        value={startDate}
                        onChange={inputHandler}
                        className="input_line"
                        type="date"
                        style={{ width: "200px" }}
                      />
                      ~
                      <input
                        id="start"
                        name="endDate"
                        value={endDate}
                        onChange={inputHandler}
                        className="input_line"
                        type="date"
                        style={{ width: "200px" }}
                      />
                    </div>
                  </section>
                </td>
                <td width="300px">
                  <div className="input_wrap input_date" style={{ gap: "5px" }}>
                    <button
                      type="button"
                      className="btn_line"
                      onClick={resetHandler}
                    >
                      초기화
                    </button>
                    <button
                      type="button"
                      className="btn_color"
                      onClick={() => {
                        getCompleteData();
                        setPage(1);
                      }}
                    >
                      검색
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="">
          <form className="my_page bbs_contain" action="" method="">
            <Routes>
              <Route path=":id" element={<ReviewCompletionStatusDetail />} />
            </Routes>

            <div className="row_bbs bbs_customqa_wrap">
              <table className="table_wrap_customerqa">
                <thead>
                  <tr>
                    <th style={{ flex: "0.2" }}>분야</th>
                    <th style={{ flex: "0.2" }}>인증 및 인정번호</th>
                    <th style={{ flex: "0.3" }}>업체명</th>
                    <th style={{ flex: "0.1" }}>인증 · 인정일</th>
                    <th style={{ flex: "0.1" }}>만료일</th>
                    <th style={{ flex: "0.15" }}>비고</th>
                  </tr>
                </thead>
                <tbody>
                  {resultData
                    .filter((el) => el.state !== 8)
                    .map((e) => {
                      return (
                        <tr key={e.id} className="tr_hover">
                          <td
                            style={{ flex: "0.2" }}
                            width="100px"
                            className="num_bbs"
                          >
                            {e.taskGroup.workflowName}
                          </td>
                          <td style={{ flex: "0.2" }} className="num_bbs">
                            <span
                              onClick={() =>
                                navigate(`/reviewcompletionstatus/${e.id}`, {
                                  state: e.id,
                                })
                              }
                              style={{ color: "dodgerBlue", cursor: "pointer" }}
                            >
                              {e.qualificationNum}
                            </span>
                          </td>
                          <td style={{ flex: "0.3" }}>
                            <p className="auth">{e.applicantName}</p>
                          </td>
                          <td style={{ flex: "0.1" }}>
                            {e.qualificationDate.replace(/-/g, ".")}
                          </td>
                          <td style={{ flex: "0.1" }} className="date_bbs">
                            {e.expiredDate.replace(/-/g, ".")}
                          </td>
                          <td style={{ flex: "0.15" }} className="date_bbs">
                            {e.state === 13
                              ? `중지(~${e?.limitDate
                                  .substring(0, 10)
                                  .replace(/-/g, ".")})`
                              : null}
                            {e.state === 2 ? "정기심사" : null}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              {resultData.length > 0 ? null : (
                <span style={{ textAlign: "center", marginTop: "10vh" }}>
                  등록된 목록이 없습니다
                </span>
              )}
              <div className="pagination_wrap">
                <div></div>

                <div className="pagination">
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={15}
                    totalItemsCount={totalItems}
                    pageRangeDisplayed={15}
                    onChange={handlePageChange}
                    prevPageText={"‹"}
                    nextPageText={"›"}
                  />
                </div>
                <div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/reviewcompletionstatus");
                    }}
                    className="list_btn"
                  >
                    목록
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default ReviewCompletionStatus;
